import React from 'react';
import { Button, Dropdown, Tag, Tooltip, Typography } from 'antd';
import {
    EyeOutlined,
    MoreOutlined,
    TeamOutlined,
    DeleteOutlined,
} from '@ant-design/icons';
import { formatDateTime, formatFileSize } from '../../utils/format';
import { getImageViewUrl } from '../../api/image';

const IMAGE_STATUS = {
    '0': { text: '正常', color: 'success' },
    '1': { text: '磁盘缺失', color: 'warning' },
};

class ImageCard extends React.Component {
    render() {
        const { image, onView, onAssign, onDelete, showAssign, showDelete } = this.props;

        const { onMediaVerified } = this.props;
        const statusCfg = IMAGE_STATUS[image.status] || { text: image.status, color: 'default' };
        const ext = (image.fileExt || '').toUpperCase() || 'IMG';
        const viewUrl = getImageViewUrl(image.id);
        const staleMissing = image.status === '1';

        const menuItems = [
            showAssign && {
                key: 'assign',
                icon: <TeamOutlined />,
                label: '分配浏览',
                onClick: () => onAssign(image),
            },
            showDelete && {
                key: 'delete',
                icon: <DeleteOutlined />,
                label: '删除记录',
                danger: true,
                onClick: () => onDelete(image),
            },
        ].filter(Boolean);

        return (
            <article className="image-card">
                <button
                    type="button"
                    className="image-card__cover"
                    onClick={() => onView(image)}
                    aria-label={`查看 ${image.fileName}`}
                >
                    <img
                        className="image-card__thumb"
                        src={viewUrl}
                        alt={image.fileName}
                        loading="lazy"
                        onLoad={() => {
                            if (staleMissing && onMediaVerified) {
                                onMediaVerified(image.id);
                            }
                        }}
                        onError={(e) => {
                            e.currentTarget.style.display = 'none';
                        }}
                    />
                    <span className="image-card__placeholder">{ext}</span>
                    <span className="image-card__ext">{ext}</span>
                    <span className="image-card__view">
                        <EyeOutlined />
                    </span>
                    <Tag className="image-card__status" color={statusCfg.color}>
                        {statusCfg.text}
                    </Tag>
                </button>

                <div className="image-card__body">
                    <Tooltip title={image.fileName}>
                        <Typography.Paragraph className="image-card__title" ellipsis={{ rows: 2 }}>
                            {image.fileName}
                        </Typography.Paragraph>
                    </Tooltip>
                    <div className="image-card__meta">
                        <span>{formatFileSize(image.fileSize)}</span>
                        <span className="image-card__meta-sep">·</span>
                        <span>{formatDateTime(image.createTime)}</span>
                    </div>
                    <div className="image-card__actions">
                        <Button
                            type="primary"
                            icon={<EyeOutlined />}
                            onClick={() => onView(image)}
                            block
                        >
                            查看
                        </Button>
                        {menuItems.length > 0 && (
                            <Dropdown menu={{ items: menuItems }} trigger={['click']}>
                                <Button icon={<MoreOutlined />} aria-label="更多操作" />
                            </Dropdown>
                        )}
                    </div>
                </div>
            </article>
        );
    }
}

export default ImageCard;
